export const adyenConfig = {
    clientKey: process.env.REACT_APP_ADYEN_CLIENT_KEY,
    environment: process.env.REACT_APP_ADYEN_CLIENT_ENV,
    clientKey5HS: process.env.REACT_APP_5HS_ADYEN_CLIENT_KEY,
    environment5HS: process.env.REACT_APP_5HS_ADYEN_CLIENT_ENV,
};

export const getAmexRestrictionText = () => {
    return "We do not currently accept payment via AMEX.";
}